export default __webpack_public_path__ + "static/simplitio-6b9325bce992aef19525241492afba6c.svg";